const APIM_PREFIX = '/ede';

export const ENDPOINT_CONSTANTS = {
  SITE_ATTRIBUTES_MASTER: `${APIM_PREFIX}/api/v1.0/bic/siteattributesmaster`,
  SEGMENTS: `${APIM_PREFIX}/api/v1/bic/segments`,
  GEOGRAPHIES: `${APIM_PREFIX}/api/v1/bic/geographies`,
  CUSTOMERS: `${APIM_PREFIX}/api/v1/bic/customers`,
  SAVE_DEFAULT_SITE_PROFILE: `${APIM_PREFIX}/api/v1.0/bic/customers/siteprofiles`,
  DELETE_DEFAULT_SITE: (id: number) =>
    `${APIM_PREFIX}/api/v1/bic/customers/siteprofiles/${id}`,
  DEFAULTSITETABLE: `${APIM_PREFIX}/api/v1/bic/segments/siteprofiles/search`,
  OFFERINGPOTENTIALANDINVESTMENT: `${APIM_PREFIX}/api/v1/bic/offerings/profiles/search`,
  CUSTOMERSITETABLE: (customerId: string) =>
    `${APIM_PREFIX}/api/v1/bic/customers/${customerId}/siteprofiles/search`,
  CUSTOMER_SITEPROFILE_SAVE_API: (customerId: string, siteId: string) =>
    `${APIM_PREFIX}/api/v1/bic/customers/${customerId}/siteprofiles/${siteId}`,
  CUSTOMER_SITEINFORMATION: (customerId: string) =>
    `${APIM_PREFIX}/api/v1/bic/customers/${customerId}/siteInformation`,
  CUSTOMER_SITE_MANAGER: (customerId: string) =>
    `${APIM_PREFIX}/api/v1/bic/customers/${customerId}/sitemanager/search`,
  COUNTRIES: `${APIM_PREFIX}/api/v1/bic/customers/countries`,
  DOWNLOAD_BULK_UPLOAD_TEMPLATE: `${APIM_PREFIX}/api/v1/bic/customers/downloadexcel`,
  BULK_UPLOAD: (customerId: string) =>
    `${APIM_PREFIX}/api/v1/bic/customers/${customerId}/siteprofiles/upload`,
  AUDIT: (messageId: string) =>
    `${APIM_PREFIX}/api/v1/bic/customers/audit/${messageId}`,
  OFFERING_MASTER: `${APIM_PREFIX}/api/v1/bic/offeringMaster`,
  OFFERING_METADATA: (offeringId: string) =>
    `${APIM_PREFIX}/api/v1/bic/offerings/${offeringId}/metadata`,
  OFFERING_PROFILE_DETAILS: (offeringId: number) =>
    `${APIM_PREFIX}/api/v1/bic/offerings/profiles/${offeringId}`,
  DELETE_OFFERINGS: (offeringId: string) =>
    `${APIM_PREFIX}/api/v1/bic/offerings/profiles/${offeringId}`,
  VALUE_CATEGORY: `${APIM_PREFIX}/api/v1/bic/valuecategories`,
  OFFERING_PRODUCTS: `${APIM_PREFIX}/api/v1/bic/offerings/products`,
  OFFERING_PROFILE_SAVE: `${APIM_PREFIX}/api/v1/bic/offerings/offeringProfile`,
  // CDM_PERMISSION_API: 'user-reg-and-alignment-int/api/b2c/v4/alignmentControllers/GetPermissionsForuser?email=onecust-tvd-vac@summerrain.us&applicationCode=ENTEDITOR',
  CDM_PERMISSION_API: (emailId: string) =>
    `/api/b2cauth/v4/alignmentControllers/GetPermissionsForuser?email=${emailId}&applicationCode=ENTEDITOR`,
  GET_SEGMENT: (CustomerID: string) =>
    `${APIM_PREFIX}/api/v1/bic/Customers/${CustomerID}/segments`,
  SITE_PREFERENCE: (customerId: string) =>
    `${APIM_PREFIX}/api/v1/bic/customers/${customerId}/recordSitePrefernce`,
  EXPORT_OFFERING_PROFILES: () =>
    `${APIM_PREFIX}/api/v1/bic/offeringprofiles/download`,
  OFFERING_PROFILE_BULK_UPLOAD: () =>
    `${APIM_PREFIX}/api/v1/bic/offeringprofiles/Upload`,
};
